<template>
  <div id="avatar-interface">
    <div
      class="ai-decoration"
      :style="style">
      <img :src="avatarDriver" :alt="alt">
    </div>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/const'

export default {
  name: 'AvatarInterface',
  props: {
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: () => 'Avatar Interface'
    },
    size: {
      type: String,
      default: () => '50px'
    },
    borderWidth: {
      type: String,
      default: () => '0px'
    },
    borderColor: {
      type: String,
      default: () => 'white'
    },
    backgroundColor: {
      type: String,
      default: () => 'rgba(23, 11, 86, 0.2)'
    },
    borderRadius: {
      type: String,
      default: () => '100%'
    }
  },
  computed: {
    avatarDriver: function() {
      return this.src ? this.src : CONSTANTS.AVATAR.DRIVER
    },
    style: function() {
      return {
        width: this.size,
        height: this.size,
        'border-width': this.borderWidth,
        'border-color': this.borderColor,
        'border-radius': this.borderRadius,
        'background-color': this.backgroundColor
      }
    }
  }
}
</script>
<style>
#avatar-interface {
  display: inline-block;
  vertical-align: middle;
}

.ai-decoration {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  -ms-border-radius: 100%;
  -o-border-radius: 100%;
  border-radius: 100%;
  overflow: hidden;
  background-color: rgba(23, 11, 86, 0.2);
}

.ai-decoration img {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-object-fit: cover;
  -moz-object-fit: cover;
  -ms-object-fit: cover;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
